#import "../fragments/email-list-item-fragment.graphql"

query GetSentEmails($limit: Int!, $cursor: String) {
    sentEmails(first: $limit, after: $cursor) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...EmailListItem
            }
        }
    }
}
